import linkedin from "./images/linkedin.png"

const socialMediaInfo =[
    {
        platformName: "Linkedin",
        logo: linkedin,
        url: "https://www.linkedin.com/in/premsiddhartha/"
    }
]

export default socialMediaInfo;